import { react2angular } from 'react2angular';
import QuestionCustomizer from './QuestionCustomizer';

angular
  .module('bb.appointments.feedback')
  .component(
    'bbQuestionCustomizer',
    react2angular(
      QuestionCustomizer,
      ['getQuestion', 'question', 'isEdit'],
      ['ModalService'],
    ),
  );
